import Vue from 'vue'
import Router from 'vue-router'
import * as exam from './exam'
import { getUser } from '@/common/js/cache'
import * as integral from './integral'

const HomePage = () => import('@/page/HomePage')
const Live = () => import('@/page/Live')
const Lession = () => import('@/page/LessionPage')
const LessionDetail = () => import('@/page/lessionDetail')
const Learn = () => import('@/page/Learn')
const LearnDetail = () => import('@/page/LearnDetail')
const LessionList = () => import('@/page/LessionList')

const my = () => import('@/page/my')
const personInfo = () => import('@/page/personInfo')
const orderList = () => import('@/page/orderList')
const collect = () => import('@/page/collect')
const study = () => import('@/page/study')
const feedback = () => import('@/page/feedback')
const message = () => import('@/page/message')
const aboutme = () => import('@/page/aboutme')
const download = () => import('@/page/download')
const login = () => import('@/page/login')
const register = () => import('@/page/register')
const watch = () => import('@/page/watch')
const notfound = () => import('@/page/notfound')
const pay = () => import('@/page/pay')
const payorder = () => import('@/page/payorder')
const address = ()=> import('@/page/address')

const classify = () => import('@/page/classify')
const search = () => import('@/page/search')
const packagelist = () => import('@/page/packagelist')
const childinfo = () => import('@/page/childinfo')
const livelist = () => import('@/page/livelist')
const graduation = () => import('@/page/graduation')

const joinIndex = () => import('@/page/join/joinIndex')
const joinForm = () => import('@/page/join/joinForm')

const rule = () => import('@/page/rule')
//注销账号
const logout = () => import('@/page/logout/logout');
const logoutcode = () => import('@/page/logout/logoutcode');

const vipMember = () =>import('@/page/vip-member/vip-member')
const vipCourse = () =>import('@/page/vip-member/vip-course')
const vipCourseNew = () =>import('@/page/vip-member/vip-course-new')
const vipCourseRecord = () =>import('@/page/vip-member/vip-course-record')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/HomePage'
    },
    {
      path: '/HomePage',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/rule',
      name: 'rule',
      component: rule
    },
    // 课程列表页
    {
      path: '/LessionList',
      name: 'LessionList',
      component: LessionList
    },
    {
      path: '/Live',
      name: 'Live',
      component: Live
    },
    {
      path: '/Lession',
      name: 'Lession',
      component: Lession
    },
    {
      path: '/Learn',
      name: 'Learn',
      component: Learn
    },
    {
      path: '/LearnDetail',
      name: 'LearnDetail',
      component: LearnDetail
    },
    {
      path: '/LessionDetail',
      name: 'LessionDetail',
      component: LessionDetail
    },
    //classify
    {
      path: '/classify',
      name: 'classify',
      component: classify
    },
    {
      path: '/my',
      name: 'My',
      component: my
    },
    {
      path: '/personinfo',
      name: 'personInfo',
      component: personInfo
    },
    {
      path: '/orderlist',
      name: 'orderList',
      component: orderList
    },
    {
      path: '/collect',
      name: 'collect',
      component: collect
    },
    {
      path: '/study',
      name: 'study',
      component: study
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback
    },
    {
      path: '/message',
      name: 'message',
      component: message
    },
    {
      path: '/aboutme',
      name: 'aboutme',
      component: aboutme
    },
    {
      path: '/download',
      name: 'download',
      component: download
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/watch/:id',
      name: 'watch',
      component: watch
    },
    {
      path: '*',
      name: 'notfound',
      component: notfound
    },
    {
      path: '/pay/:id',
      name: 'pay',
      component: pay
    },
    {
      path: '/payorder',
      name: 'payorder',
      component: payorder
    },
    {
      path: '/address',
      name: 'address',
      component: address
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/packagelist',//package 类型
      name: 'packagelist',
      component: packagelist
    },
    {
      path: '/childinfo',
      name: 'childinfo',
      component: childinfo
    },
    {
      path: '/livelist',
      name: 'livelist',
      component: livelist
    },
    {
      path: '/graduation',
      name: 'graduation',
      component: graduation
    },
    // 考试一类
    {
      path: '/examCourse',
      name: 'examCourse',
      component: exam.EXAM_COURSE
    },
    {
      path: '/exam',
      name: 'exam',
      component: exam.EXAM_HOME,
    },
    {
      path: '/DayPractice',
      name: 'DayPractice',
      component: exam.DAY_PRACTICE
    },
    {
      path: '/TrueTopic',
      name: 'TrueTopic',
      component: exam.TRUE_TOPIC
    },
    {
      path: '/Assessment',
      name: 'Assessment',
      component: exam.ASSESSMENT
    },
    {
      path: '/Wrong',
      name: 'Wrong',
      component: exam.WRONG
    },
    {
      path: '/CollectTopic',
      name: 'CollectTopic',
      component: exam.COLLECT
    },
    {
      path: '/QuestionRecord',
      name: 'QuestionRecord',
      component: exam.QUESTION_RECORD
    },
    {
      path: '/AnswerSheet',
      name: 'AnswerSheet',
      component: exam.ANSWER_SHEET
    },
    {
      path: '/ExamChapter',
      name: 'ExamChapter',
      component: exam.EXAM_CHAPTER
    },
    {
      path: '/ExamStartChapter',
      name: 'ExamStartChapter',
      component: exam.EXAM_CHANPTER_START
    },
    {
      path: '/MockExamList',
      name: 'MockExamList',
      component: exam.MOCK_EXAM_LIST
    },
    {
      path: '/StartMockExam',
      name: 'StartMockExam',
      component: exam.MOCK_EXAM
    },
    {
      path: '/StartTrueExam',
      name: 'StartTrueExam',
      component: exam.START_TRUE_EXAM
    },
    {
      path: '/WrongAnlysis',
      name: 'WrongAnlysis',
      component: exam.WRONG_ANALYSIS
    },
    {
      path: '/joinIndex',
      name: 'joinIndex',
      component: joinIndex,
    },
    {
      path: '/joinForm',
      name: 'joinForm',
      component: joinForm,
    },
    {
      path:'/integral',
      name:'integral',
      component:integral.integral
    },
    {
      path:'/integrallist',
      name:'integrallist',
      component:integral.integrallist
    },
    {
      path: '/logoutcode',
      name: 'logoutcode',
      component: logoutcode
    },
    {
      path: '/logout',
      name: 'logout',
      component: logout
    },
    {
      path:'/vip-member',
      name:'vip-member',
      component:vipMember
    },
    {
      path:'/vip-course',
      name:'vip-course',
      component:vipCourse
    },
    {
      path:'/vip-course-new',
      name:'vip-course-new',
      component:vipCourseNew
    },
    {
      path:'/vip-course-record',
      name:'vip-course-record',
      component:vipCourseRecord
    }  
  ]
})


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


let routeList = [ 'exam', 'DayPractice', 'TrueTopic', 'Assessment', 'Wrong', 'CollectTopic', 'QuestionRecord', 'AnswerSheet', 'ExamChapter', 'ExamStartChapter', 'MockExamList', 'StartMockExam', 'StartTrueExam', 'WrongAnlysis','integral']

// 路由守卫
// 进入特定页面前判断是否已登录，未登录跳转到登录页面
router.beforeEach((to, from, next) => {
  if (routeList.indexOf(to.name) > -1) {
    if (!getUser()) {
      console.log(this.$router)
      next({name:'login'})
    }
  }
  next()
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js